import { Program } from "pages/UserDetails/components/Playlists/types";

export type ProgramHistory = {
  id: number;
  program_type?: "maintenance" | "intensive";
  start_date?: string;
  end_date?: string;
};

export type Account = {
  id: number;
  firstName: string;
  lastName: string;
  contactPhoneNumber?: string;
  activityPhoneNumber?: string;
  timeZone?: string;
  summary?: string;
  programStartOn?: string;
  programEndOn?: string;
  bdlProgramStartOn?: Date;
  bdlProgramEndOn?: Date;
  user?: User;
  specialist?: User;
  playlists?: Playlist[];
  callRecords?: CallRecord[];
  callSchedules?: CallSchedule[];
  latestProgram?: ProgramHistory;
  createdOn: string;
  updatedOn?: string;
  deletedAt?: string;
  leadType?: string;
  Id_Ehr?: string;
  latest_program_type?: string;
  latest_program_type_status?: string;
};

export type User = {
  id?: number;
  email?: string;
  firstName?: string;
  lastName?: string;
  createdOn?: string;
  updatedOn?: string;
  isSpecialist?: boolean;
  isTestUser: boolean;
};

export type VoiceMessage = {
  id: number;
  audioFile?: AudioFile;
  feature?: Feature;
  focus?: string;
  category?: string;
  title?: string;
  templateLink?: string;
  cognitiveDomains?: CognitiveDomain[];
  deactivationNote?: string;
  createdOn?: string;
  updatedOn?: string;
  deletedAt?: string;
  difficulty?: string;
  recordedBy: User;
};

export type AudioFile = {
  id?: number;
  filename?: string;
  callSid?: string;
  durationInSeconds?: number;
  downloadUrl?: string;
  createdOn?: string;
  updatedOn?: string;
};

export type Playlist = {
  id?: number;
  account?: Account;
  title?: string;
  isActive?: boolean;
  startOn?: Date;
  endOn?: Date;
  playlistVoiceMessages?: PlaylistVoiceMessage[];
  createdOn?: Date;
  updatedOn?: Date;
  deletedAt?: Date;
  isFreeTrial?: boolean;
  isTracked?: boolean;
  program?: Program;
};

export type PlaylistVoiceMessage = {
  id?: number;
  playlist?: Playlist;
  voiceMessage?: VoiceMessage;
  order?: number;
  createdOn?: Date;
  updatedOn?: Date;
  deletedAt?: Date;
};

export type ActivityRecord = {
  id?: number;
  callSid?: string;
  voiceMessage?: VoiceMessage;
  isCompleted?: boolean;
  durationInSeconds?: number;
  startedAt?: Date;
  stoppedAt?: Date;
  callRecord?: CallRecord;
};

export type CallRecord = {
  sid?: string;
  recordingDownloadUrl?: string;
  durationInSeconds?: number;
  outcome?: CallOutcome;
  type?: CallType;
  account?: Account;
  user?: User;
  programRating?: number;
  fullProgramRatingResponse?: string;
  reflectionOnLearnings?: string;
  playlist?: Playlist;
  createdOn?: Date;
  updatedOn?: Date;
  activities?: ActivityRecord[];
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hbacalldata: any;
  sessionCount?: number;
  errorDetails?: string | null;
  hangupDetails?: string | null;
};

export enum CallFlowVersion {
  V1 = "V1",
  V2 = "V2",
}

export type CallSchedule = {
  id?: number;
  cronExpression?: string;
  scheduleDescription?: string;
  timeZone?: string;
  createdOn?: Date;
  updatedOn?: Date;
  callFlowVersion?: CallFlowVersion;
  playlists?: Playlist[];
};

export enum CallOutcome {
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
  IN_PROGRESS = "IN PROG",
}

export enum CallType {
  INBOUND_CALL_V2 = "INBOUND_CALL_V2",
  OUTBOUND_CALL_V2 = "OUTBOUND_CALL_V2",

  INBOUND_CALL_BDL = "INBOUND_CALL_BDL",
  OUTBOUND_CALL_BDL = "OUTBOUND_CALL_BDL",

  // Deprecated
  OUTBOUND_INITIAL = "OUTBOUND_INITIAL",
  OUTBOUND_FOLLOW_UP = "OUTBOUND_FOLLOW_UP",
}

export enum Feature {
  Instructions = "Instructions",
  HealthyBrainActivity = "Healthy Brain Activity",
  Lifestyle = "Lifestyle",
  CompensatoryStrategies = "Compensatory Strategies",
}

export enum CognitiveDomain {
  // Healthy Brain Activities
  ShortTermMemory = "Short term memory",
  LongTermMemory = "Long term memory",
  ProceduralMemory = "Procedural memory",
  AuditoryProcessing = "Auditory processing",
  ThoughtOrganization = "Thought organization",
  ReasoningLogic = "Reasoning/logic",
  ProblemSolving = "Problem solving",
  PlanningAndOrganization = "Planning and organization",
  AttentionAndConcentration = "Attention and Concentration",
  ExpressiveLanguage = "Expressive Language",
  ReceptiveLanguage = "Receptive Language",
  Transition = "Transition",

  // Instructions
  Intro = "Intro",
  Outro = "Outro",
  RecordingFeedback = "Recording Feedback",
  ClientReflection = "Client Reflection",
}

export enum StatusView {
  Active = "Active",
  Deleted = "Deleted",
  All = "All",
}

export enum SortingDirection {
  Ascending = "ASC",
  Descending = "DESC",
}

export interface Specialist {
  id: number;
  firstName: string;
  lastName: string | null;
  email: string;
}

// Define the specialist option interface for dropdown
export interface SpecialistOption {
  value: number;
  label: string;
  firstName: string;
  lastName: string;
  fullName: string;
  prefix: string;
  email: string;
}
